import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { SemantriaAPIService } from '../semantria-api.service';

export interface SemantriaFeature {
  feature: string;
  settings?: string[];
  description: string;
}

export interface AccountLimit {
  description: string;
  limit_type: string;
  max_value: number;
  min_value: number;
}

export interface DeepModelType {
  language_id: string;
  name: string;
  description: string;
}

@EnableClassTelemetry()
@Injectable()
export class SemantriaFeaturesService extends SemantriaAPIService {
  getAccountLimits(): Promise<AccountLimit[]> {
    return this.get<AccountLimit[]>('/limit-types/');
  }

  getAllFeatures(): Promise<SemantriaFeature[]> {
    return this.get<SemantriaFeature[]>('/features/');
  }

  getAllDeepModels(): Promise<DeepModelType[]> {
    return this.get<DeepModelType[]>('/deep-models/');
  }
}
